export enum MenuList {
	Dashboard = 'Dashboard',
    Calendar = 'Calendar',
    PeopleManagement = 'People Management',
    People = 'People',
    ModuleSettings = 'Module Settings',
    GoBackToATS = 'Go back to ATS',
}